// extracted by mini-css-extract-plugin
export default {"indicator":"HOydOW"};